export enum AuthCodes {
    UsernameExists = "UsernameExistsException",
    AliasExists = "AliasExistsException",
    CodeMismatch = "CodeMismatchException"
}